import React from "react";
import "./Card.css";

const Card = ({ children, padding = "20px" }) => {
  return (
    <div className="base-card" style={{ padding }}>
      {children}
    </div>
  );
};

export default Card;
